/**
 * Project API — typed wrappers around legacy projectApi.js.
 */
import {
  getProjectById as legacyGetProjectById,
  getFilesForProject as legacyGetFilesForProject,
  getFilesForProjectByType as legacyGetFilesForProjectByType,
  getGuestUser as legacyGetGuestUser,
  setGuestUsername as legacySetGuestUsername,
} from '../apiServices/projectApi';
import { transformItems } from '@/lib/transform';
import type { NormalizedItem } from '@/components/itemList/types';

// ── Types ───────────────────────────────────────────────────────────

/** Raw project/files response from API (DynamoDB format, pre-transform) */
export interface RawApiResponse {
  response: {
    Item?: Record<string, unknown>;
    Items?: Record<string, unknown>[];
    invitedUsers?: Record<string, unknown>[];
  };
}

// ── Functions ───────────────────────────────────────────────────────

export async function getProjectById(projectId: string): Promise<RawApiResponse> {
  return legacyGetProjectById(projectId);
}

export async function getFilesForProjectByType(
  projectId: string,
  fileType: string,
): Promise<RawApiResponse> {
  return legacyGetFilesForProjectByType(projectId, fileType);
}

/**
 * Fetch all files for a project, returned as normalized items.
 * Used by ResourcePage on cache miss.
 */
export async function getProjectFilesNormalized(projectId: string): Promise<NormalizedItem[]> {
  const res = await legacyGetFilesForProject(projectId);
  return transformItems(res.response.Items || []);
}

export async function getGuestUser(hash: string): Promise<PromiseSettledResult<unknown>[]> {
  return legacyGetGuestUser(hash);
}

export async function setGuestUsername(
  hash: string,
  firstname: string,
  lastname: string,
): Promise<unknown> {
  return legacySetGuestUsername(hash, firstname, lastname);
}
